export default [

     {
          path: '/kriformulavariable',
          name: 'Kriformulavariable',
          component: () => import("@/views/Page/Kriformulavariable/Kriformulavariable.vue"),
           meta: {
               title: 'Kri Formula Variables',
          },
     }
];